import React from 'react'
import _ from 'lodash'
import { Form } from 'reactstrap'

import MultiLangInput from 'components/Input/MultiLang'
import Lang from 'Lang/General'

const TagForm = ({
  tagType,
  currentTag,
  onChangeTagsHOC,
  lang
}) => {
  const updateTag = ( key, val ) => {
    let tmp = _.cloneDeep( currentTag )
    tmp[ key ] = val
    onChangeTagsHOC( tagType, tmp )
  }
  return(
    <>
      <Form>
        <MultiLangInput
          label={ Lang[ 'NAME' ][ lang ] }
          value={ currentTag.name }
          onChange={ val => updateTag( 'name', val ) }
          selectedLanguage={ lang } />
      </Form>
    </>
  )
}

export default TagForm